import './iframe.scss';
import { uniqueID } from './../../utilities/js/helper';
import iFrameResize from 'iframe-resizer/js/iframeResizer';

/*
The 'iframe-resizer' package should always be in the version '4.3.11'. This ensures, that we use the MIT licence and we do not need a licence key
https://www.npmjs.com/package/iframe-resizer/v/4.3.11?activeTab=versions
*/
class Iframe {
    constructor ($element, options) {
        const defaults = {
        };

        this.settings = Object.assign({}, defaults, options);
        this.$iframe = $element;

        this.visitorId = null;

        this.initialize();
    }

    initialize () {
        const iframeId = 'iframe_' + uniqueID();
        this.$iframe.setAttribute('id', iframeId);

        this._resizerInstances = iFrameResize({
        }, '#' + iframeId);

        const getVisitorId = (callback) => {
            const _paq = window._paq = window._paq || [];
            _paq.push([function () {
                const visitorId = this.getVisitorId();
                callback(visitorId);
            }]);
        };

        const getConsentInfo = () => {
            if (!window.UC_UI) {
                return { visitorId: this.visitorId, consentMatomoStatus: null };
            }
            const services = window.UC_UI.getServicesBaseInfo ? window.UC_UI.getServicesBaseInfo() : [];
            const consentMatomo = services.filter(data => data.id === 'u6fxocwTs');
            const consentMatomoStatus = consentMatomo[0] ? consentMatomo[0].consent.status : null;

            const sendDataObject = {
                visitorId: this.visitorId,
                consentMatomoStatus: consentMatomoStatus
            };

            return sendDataObject;
        };

        const checkAndSend = () => {
            window.setTimeout(() => {
                const sendDataObject = getConsentInfo();
                const api = this.$iframe.iFrameResizer || this.$iframe.iframeResizer;
                if (api && typeof api.sendMessage === 'function') {
                    api.sendMessage(sendDataObject);
                }
            }, 1000);
        };

        getVisitorId((visitorId) => {
            this.visitorId = visitorId;
        });

        checkAndSend();

        window.addEventListener('UC_UI_CMP_EVENT', () => {
            checkAndSend();
        });
    }
}

export { Iframe };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const initializeIframes = () => {
            const $$iframe = $context.querySelectorAll('[data-iframe="root"]');
            for (let i = 0; i < $$iframe.length; i++) {
                const $iframe = $$iframe[i];

                $iframe.API = new Iframe($iframe);
            }
        };

        if (window.UC_UI && window.UC_UI.isInitialized && window.UC_UI.isInitialized()) {
            initializeIframes();
        } else {
            window.addEventListener('UC_UI_INITIALIZED', () => {
                initializeIframes();
            });
        }
    }
});
